import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet"; // ✅ Ajout pour SEO
import "../styles/maquettes.css";

export default function MaquetteTemplate() {
  const { id } = useParams();
  const machineName = id.toLowerCase();

  const [text, setText] = useState("");

  useEffect(() => {
    fetch(`/machines/${machineName}/${machineName}1.txt`, { cache: "no-store" })
      .then((res) => res.text())
      .then((data) => setText(data))
      .catch(() => setText("Texte introuvable."));
  }, [machineName]);

  return (
    <div className="maquette-container">
      {/* ✅ Balises SEO dynamiques */}
      <Helmet>
        <title>Maquettes réalisées par Dominique Formaz d'après les archives de Séraphin Clerc</title>
        <meta
          name="description"
          content={`Découvrez les maquette de ${id}, réalisées d'après les archives de Séraphin Clerc, inventeur fictif du XIXe siècle.`}
        />
        <meta
          name="keywords"
          content="Séraphin Clerc, Jules Verne, maquette, inventions fictives, XIXe siècle, steampunk, rétrofuturisme, vaporisme"
        />
        <meta
          name="google-site-verification"
          content="google231946896bc49534.html"
        />
      </Helmet>

      {/* Bouton vers archives */}
      <div style={{ textAlign: "right", marginBottom: "16px" }}>
        <Link to={`/machines/${id}/archives`} className="steampunk-button">
          Archives
        </Link>
      </div>

      {/* Plaque */}
      <div className="maquette-image">
        <img
          src={`/machines/${machineName}/plaque_${machineName}.jpg`}
          alt={`Plaque ${id}`}
          style={{ maxWidth: "400px", width: "100%", height: "auto" }}
        />
      </div>

      {/* Vidéo */}
      <div className="maquette-video">
        <video
          autoPlay
          muted
          loop
          playsInline
          controls
          style={{ maxWidth: "100%", margin: "20px 0" }}
        >
          <source
            src={`/machines/${machineName}/${machineName}.mp4`}
            type="video/mp4"
          />
          Votre navigateur ne supporte pas la vidéo.
        </video>
      </div>

      {/* Images */}
      <div className="maquette-images">
        <img
          src={`/machines/${machineName}/${machineName}1.png`}
          alt={`${id} vue 1`}
          style={{ maxWidth: "100%", marginBottom: "16px" }}
        />
        <img
          src={`/machines/${machineName}/${machineName}2.png`}
          alt={`${id} vue 2`}
          style={{ maxWidth: "100%", marginBottom: "16px" }}
        />
      </div>

      {/* Texte */}
      <div className="maquette-texte">
        <p style={{ whiteSpace: "pre-line" }}>{text}</p>
      </div>
    </div>
  );
}
